import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["button", "buttonFunc", "buttonName", "children", "elevated", "regIcon", "smallIcon", "theme"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { BORDER, FONT_COLOR, BACKGROUND } from './TAGNotification.type';
import TAGTypography from '../TAGTypography/TAGTypography';
import TAGSvgIcon from '../TAGSvgIcon/TAGSvgIcon';
import { ICON_SIZES } from '../../../constants/constant';

var TAGNotification = function TAGNotification(_ref) {
  var button = _ref.button,
      buttonFunc = _ref.buttonFunc,
      buttonName = _ref.buttonName,
      children = _ref.children,
      elevated = _ref.elevated,
      regIcon = _ref.regIcon,
      smallIcon = _ref.smallIcon,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  var themeStyle = theme && {
    border: elevated ? '' : BORDER["".concat(theme)],
    backgroundColor: BACKGROUND["".concat(theme)],
    color: FONT_COLOR["".concat(theme)],
    alignItems: 'center'
  };
  return React.createElement(Stack, {
    sx: {
      width: '100%'
    },
    spacing: 2
  }, React.createElement(Alert, _objectSpread(_objectSpread({
    severity: "success"
  }, props), {}, {
    icon: regIcon || smallIcon ? React.createElement(TAGSvgIcon, {
      icon: "CircleWarning",
      size: smallIcon ? ICON_SIZES.xs : ICON_SIZES.md,
      color: FONT_COLOR["".concat(theme)]
    }) : false,
    variant: "standard",
    elevation: elevated ? 5 : 0,
    action: button && // TODO: Button need to be replaced by TAG button
    React.createElement(Button, {
      color: "inherit",
      size: "small",
      sx: {
        color: 'text.secondary',
        letterSpacing: '1px'
      },
      onClick: button && buttonFunc
    }, button && (buttonName || 'button')),
    sx: themeStyle
  }), children === typeof 'string' ? React.createElement(TAGTypography, {
    variant: "bodySmallBook"
  }, children) : children));
};

export default TAGNotification;